/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { TProducedAddisBody } from '../types';

import { notifications } from '@mantine/notifications';
// I18n
import { useTranslation } from 'react-i18next';

// Store
import useStore from '@store/index';

export const producedAddis = (
	data: TProducedAddisBody
): Promise<{
	response: any;
}> => {
	return apiClient.post('/offsets/produced_addis', {
		...data,
	});
};

export const useProducedAddis = () => {
	const { t } = useTranslation();
	const { setOffsetProducedAddis } = useStore();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: producedAddis,
		onSuccess: (response: any) => {
			setOffsetProducedAddis(response.producedAddis);
		},
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading };
};
